import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {fetchDataIfReady, setAlert} from '../modules/fetch.action.js'
import {handleChange, handleSubChange, areFieldsNotEmpty, areFieldsValid, sanitizePayload} from '../modules/functions.js'
import i18n_texts from '../i18n.js';

const e = React.createElement;


function Settings(props) {
  React.Component.constructor.call(this);

  var new_state = {};
  var login_data = props.apiData["login"]["data"];
  new_state.parameters = (login_data.parameters) ? JSON.parse(login_data.parameters) : {};
  for(var i = 0; i < props.fields.length; i++) {
    var f = props.fields[i];
    new_state[f.dbcol] = login_data[f.dbcol];
  }
  this.state = new_state;
}
Settings.prototype = Object.create(React.Component.prototype);


Settings.prototype.render = function() {
  var form_fields = [];
  form_fields = this.formatFields(this.props.fields, form_fields, 0, false);
  if(this.props.parameter_fields) {
    form_fields[form_fields.length] = e('div', {key:"offset", style:{height:"22px"}}, "");
    form_fields = this.formatFields(this.props.parameter_fields, form_fields, form_fields.length, true);
  }
  form_fields[form_fields.length] = e('div', {key:"submit"}, e('input', {type:"submit", value:i18n_texts["core_settings_save"][this.props.lang], disabled:this.props.is_fetching}));

  return e('div', null, [e('strong', {key:"settings-title"}, i18n_texts["core_settings_title"][this.props.lang]), e('div', {key:"settings-form", className:"card settings"}, e('form', {onSubmit:function(e) {this.handleCreate(e)}.bind(this)}, form_fields))]);
}

Settings.prototype.formatFields = function(fields, form_fields, c_i, is_parameters) {
  for(var i = 0; i < fields.length; i++) {
    var f = fields[i];
    var field_value = (this.state[f.dbcol]) ? this.state[f.dbcol] : "";
    if(is_parameters) field_value = (this.state.parameters[f.dbcol]) ? this.state.parameters[f.dbcol] : "";
    var field_handleChange = handleChange.bind(null, this, f.dbcol);
    if(is_parameters) field_handleChange = handleSubChange.bind(null, this, f.dbcol, "parameters", this.state.parameters);
    if(f.type === "display") {
      form_fields[c_i+i] = e('div', {key:c_i+i}, field_value);
    } else if(f.type === "text") {
      form_fields[c_i+i] = e('div', {key:c_i+i}, e('input', {
        type:"text",
        placeholder:f.placeholder,
        value:field_value,
        onChange:field_handleChange,
        maxLength:f.maxLength,
      }));
    } else if(f.type === "date") {
      form_fields[c_i+i] = e('div', {key:c_i+i}, e('input', {
        type:"date",
        placeholder:f.placeholder,
        value:field_value,
        onChange:field_handleChange,
        maxLength:"10",
      }));
    } else if(f.type === "select") {
      var select_fields = [];
      for(var so_i = 0; so_i < f.options.length; so_i++) {
        var o = f.options[so_i];
        select_fields[so_i] = e('option', {key:"so"+so_i, value:o.value}, o.label);
      }
      form_fields[c_i+i] = e('select', {key:c_i+i, name:f.dbcol, onChange:field_handleChange, value:field_value}, select_fields);
    }
  }
  return form_fields;
}

Settings.prototype.handleCreate = function(e) {
  e.preventDefault();
  var payload = {};
  for(var i = 0; i < this.props.fields.length; i++) {
    var f = this.props.fields[i];
    payload[f.dbcol] = this.state[f.dbcol] ? this.state[f.dbcol] : "";
    if(f.type === "select" && payload[f.dbcol] === "") payload[f.dbcol] = f.defaultValue;
  }
  if(this.props.parameter_fields) {
    payload.parameters = {};
    for(var i = 0; i < this.props.parameter_fields.length; i++) {
      var f = this.props.parameter_fields[i];
      payload.parameters[f.dbcol] = this.state.parameters[f.dbcol] ? this.state.parameters[f.dbcol] : "";
      if(f.type === "select" && payload.parameters[f.dbcol] === "") payload.parameters[f.dbcol] = f.defaultValue;
    }
  }

  if(!this.props.required_fields || (this.props.required_fields && areFieldsNotEmpty(this.props.required_fields, payload, this.props.setAlert))) {
    if(!this.props.validate_fields || (this.props.validate_fields && areFieldsValid(this.props.validate_fields, payload, this.props.setAlert))) {
      if(!this.props.required_parameter_fields || (this.props.required_parameter_fields && areFieldsNotEmpty(this.props.required_parameter_fields, payload.parameters, this.props.setAlert))) {
        if(!this.props.validate_parameter_fields || (this.props.validate_parameter_fields && areFieldsValid(this.props.validate_parameter_fields, payload.parameters, this.props.setAlert))) {
          if(this.props.is_fetching === false || this.props.is_fetching === null) {
            if(this.props.validate_fields) {
              payload = sanitizePayload(this.props.validate_fields, payload);
            }
            if(this.props.validate_parameter_fields) {
              payload.parameters = sanitizePayload(this.props.validate_parameter_fields, payload.parameters);
            }
            payload.session_token = this.props.session_token;
            var success_alert = (typeof this.props.success_alert !== 'undefined') ? success_alert : true;
            this.props.fetchDataIfReady(this.props.config.api_token, this.props.api_block, this.props.api_method, this.props.config.api_url+this.props.api_endpoint, JSON.stringify(payload), null, true, false, success_alert, "login", false, null, this.props.api_block_clear);
            this.setState(payload); // sets the state to the validated/cleaned payload, exactly as it was sent to the API.
          }
        }
      }
    }
  }
}


function mapStateToProps(state, ownProps) {
  var session_token = null, is_fetching = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData[ownProps.api_block] !== undefined && state.apiData[ownProps.api_block].isFetching !== undefined) {
    is_fetching = state.apiData[ownProps.api_block].isFetching;
  }

  return {
    session_token: session_token,
    is_fetching: is_fetching,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/Settings.js
// module id = 234
// module chunks = 0